var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@dixa/lib-shared-habla';
import isEmail from 'validator/lib/isEmail';
import { userModalApi } from 'components/usersModal';
/**
 * Synchronously validates the to, from and subject form data.
 *
 * @param formData The form data.
 */
export function validate(formData) {
    var _a, _b;
    const errors = {};
    if (!formData) {
        return errors;
    }
    const { toUser, fromEmails, subject } = formData;
    if (!toUser || (Array.isArray(toUser) && toUser.length === 0)) {
        errors.toUser = { _error: 'Required' };
    }
    else if (((_b = (_a = toUser === null || toUser === void 0 ? void 0 : toUser[0]) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.email) === undefined) {
        errors.toUser = { _error: 'To email is required' };
    }
    if (!fromEmails) {
        errors.fromEmails = { _error: 'Required' };
    }
    else if (fromEmails && !isEmail(fromEmails)) {
        errors.fromEmails = { _error: 'From email is not valid' };
    }
    if (!subject) {
        errors.subject = { _error: 'Required' };
    }
    return errors;
}
/**
 * Asynchronously validates that uniqueness of the email.
 *
 * @param formData The form data.
 * @param dispatch The redux dispatch function.
 * @param props The props.
 */
export function asyncValidate(formData, _dispatch, props) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { change } = props;
        const { email, id } = ((_b = (_a = formData === null || formData === void 0 ? void 0 : formData.toUser) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.user) || {};
        if (!email || !isEmail(email) || id)
            return Promise.resolve();
        return userModalApi.validateEmail(email).then(({ data }) => {
            const { available, conflicting_id: userId } = data;
            if (!available && userId && change) {
                change('toUser[0].user.id', userId);
            }
            return Promise.resolve({
                email: userId ? (_jsxs("span", { children: ["Email is already used by another user", ' ', _jsx(Button, Object.assign({ onClick: () => {
                                props.userModalGetUser({ userId });
                            }, variant: "secondary" }, { children: "Load user" }))] })) : ('Email is already used by another user'),
            });
        });
    });
}
